// One fixed factual GSM-7 part. The server never accepts caller-selected copy.
export const NEXT_STOP_SMS_TEXT = "Sugar Gremlin: Your order is our next stop! We're on our way. Not home? Reply to this text. See you soon!"

export type DeliverySmsState = 'not-sent' | 'sending' | 'accepted' | 'delivered' | 'failed' | 'unknown' | 'disabled' | 'unavailable'
export type DeliverySmsView = {
  state: DeliverySmsState
  message: string
  canSend: boolean
  canCheckStatus: boolean
  confirmation: string | null
  recipientHint: string | null
}

// A persisted, newly changed normal transition alone opens the OPTIONAL preview.
// This function never sends, and reopening an order never satisfies this gate.
export function shouldOfferNextStopSms(
  result: { saved?: boolean; changed?: boolean; currentStatus?: string } | null,
  requestedStatus: string,
  orderId: string,
  refreshed: { orderId: string; fulfilment: { status: string | null }; deliverySms?: DeliverySmsView } | null | undefined,
) {
  return Boolean(result?.saved === true && result.changed === true
    && result.currentStatus === 'out_for_delivery' && requestedStatus === 'out_for_delivery'
    && refreshed?.orderId === orderId && refreshed.fulfilment.status === 'out_for_delivery'
    && refreshed.deliverySms?.canSend)
}
